<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-1" outlined :style="maxHeight">
        <v-row>
        <v-card-title class="pl-6">Queues in {{ outlet.name }}</v-card-title>
          <v-col style="text-align: right;" class="pr-12">
        <v-btn v-if="user === 'admin'" class="ma-1 text-right font-weight-bold" color="primary" @click="editOutlet()"> Edit Outlet</v-btn>
        <v-btn class="ma-1 text-right font-weight-bold" color="success" @click="create()"> + Add Queue</v-btn>
          </v-col>
        </v-row>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
            outlined
            dense
            class="ma-1 pl-2 pt-2 col-6"
        ></v-text-field>
        <div>
          <v-data-table
              :headers="headers"
              item-key="name"
              :items="Object.values(queues)"
              :search="search"
              dense
              class="display-3 font-weight-medium"
          >
            <template v-slot:item.actions="{ item }">
              <div
              >
                <v-icon
                    class="mr-8"
                    color="primary"
                    @click="detail(item)"
                >
                  mdi-eye
                </v-icon>
                <v-icon
                    @click="editQueue(item)"
                >
                  mdi-pencil
                </v-icon>

              </div>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'queues',
  props: ['outlet', 'queues', 'user'],
  data: () => ({
    headers: [
      {
        text: 'Queue',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Description',
        value: 'description',
      },
      {
        text: 'Interval',
        value: 'interval',
      },
      {
        text: 'Limit',
        value: 'limit',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }
    ],
    search: null,
    breadcrumbsItems: '',
  }),
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
    maxHeight() {
      return {
        maxHeight: window.innerHeight + 'px'
      }
    }
  },
  methods: {
    create() {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/create'
    },
    detail(q) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id
    },
    editQueue(q) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id + '/edit'
    },
    monitorQueue(q) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id + '/monitor'
    },
    editOutlet(){
      window.location.href = '/outlet/' + this.outlet.id + '/edit/'
    }
  },
  beforeMount() {
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/edit',
        link: true,
        text: this.outlet.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Queues',
      },
    ];
  }
}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Queues/Queues.vue